import { Fragment } from "react";
import PropTypes from "prop-types";
import { Subtitle } from "components/atoms/Text";

const NewsCard = ({ title, author, image, dateposted }) => {
    return (
        <Fragment>
            <div className="w-full flex-col justify-between">
                <div className="">
                    <img src={`/images/news/${image}.png`} className="w-full object-cover h-[220px] phone:h-[180px] rounded-lg" alt={image} />
                    <h3 className="font-medium text-heading-5 pt-4 pb-6">{title}</h3>
                </div>
                <div className="flex items-center space-x-3">
                    <img src="/images/news/author.png" className="w-[28px] h-[28px]" alt={author} />
                    <div className="flex items-center space-x-2">
                        <h3 className="font-medium tracking-text leading-[17.39px] text-sm">{author}</h3>
                        <img src="/images/news/dots.svg" alt="dots" />
                        <Subtitle classNames="!leading-[17.39px] !text-[14px]">{dateposted}</Subtitle>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

NewsCard.propTypes = {
    title: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    dateposted: PropTypes.string.isRequired
};

export default NewsCard;